// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__JBKUj"};